import shortid from 'shortid';

import getServiceToken from '../data/ServiceAccountAccess';
import sheetConstants from '../data/sheetConstants';

import {attendeeToSheetRow} from './attendeeToSheetRow';

const appendReservation = async ({
    sheetId,
    attendee,
    bearerToken,
    reservationId
}) => {
    const inputOption = 'USER_ENTERED';
    const sheetName = sheetConstants.reservationsSheetName;
    const response = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${sheetName}:append?valueInputOption=${inputOption}`, {
        body: JSON.stringify({
            values: attendeeToSheetRow(attendee, reservationId)
        }),
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${bearerToken}`,
            'Content-type': 'application/json'
        },
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    return response.json();
};

const setMetadataRequest = (rowNumber, id, vendorId) => ({
    requests: [
        {
            createDeveloperMetadata: {
                developerMetadata: {
                    location: {
                        dimensionRange: {
                            dimension: 'ROWS',
                            endIndex: rowNumber,
                            sheetId: sheetConstants.reservationsSheetId,
                            startIndex: rowNumber - 1
                        }
                    },
                    metadataKey: 'id',
                    metadataValue: id,
                    visibility: 'DOCUMENT'
                }
            }
        },
        {
            createDeveloperMetadata: {
                developerMetadata: {
                    location: {
                        dimensionRange: {
                            dimension: 'ROWS',
                            endIndex: rowNumber,
                            sheetId: sheetConstants.reservationsSheetId,
                            startIndex: rowNumber - 1
                        }
                    },
                    metadataKey: 'vendorId',
                    metadataValue: vendorId,
                    visibility: 'DOCUMENT'
                }
            }
        }
    ]
});

const setMetadata = async ({
    updateValuesResponse: {updates: {spreadsheetId, updatedRange}},
    vendorId,
    bearerToken,
    reservationId
}) => {
    const [, rowUpdated] = /![A-Z]+(\d+):[A-Z]+\d+/g.exec(updatedRange);
    const response = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}:batchUpdate`, {
        body: JSON.stringify(setMetadataRequest(parseInt(rowUpdated), reservationId, vendorId)),
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${bearerToken}`,
            'Content-type': 'application/json'
        },
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    return reservationId;
};

export default async (sheetId, attendee) => {
    const bearerToken = await getServiceToken();
    const reservationId = shortid.generate();

    const updateValuesResponse = await appendReservation({
        sheetId,
        attendee,
        bearerToken,
        reservationId
    });

    return setMetadata({
        updateValuesResponse,
        vendorId: attendee.vendorId,
        bearerToken,
        reservationId
    });
};



// WEBPACK FOOTER //
// ./src/event/appendReservation.js